import { useEffect } from "react"

import PaywallBundling from "./PaywallBundling"
import PaywallNoBundling from "./paywallNoBundling/PaywallNoBundling"
import PaywallReferralModal from "./PaywallReferralModal"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import {
  useCoachIntakeFormQuestionnaireQuery,
  useCoachPostSelectionQuestionnaireQuery,
  useUserQuery,
} from "../../networking/queries"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { requireAuth } from "../../util/auth"
import { useRouter } from "../../util/router"
import { localStorageItems } from "../../util/storage"

const Paywall = () => {
  useDocumentTitle("Joon - Start Trial")
  const { user } = useUserQuery()
  const router = useRouter()

  // This is called here to preload/cache questionnaires for survey step
  useCoachIntakeFormQuestionnaireQuery()
  useCoachPostSelectionQuestionnaireQuery()

  useEffect(() => {
    // if needs to see pre paywall, redirect to pre-paywall questionnaire
    const needsToSeePrePaywall = localStorage.getItem(
      localStorageItems.needsToSeePrePaywall
    )
    if (needsToSeePrePaywall) {
      localStorage.removeItem(localStorageItems.needsToSeePrePaywall)
      router.push("/paywall/questionnaire")
      return
    }

    // otherwise, show paywall and track event
    trackAnalyticEvent(ANALYTIC_EVENTS.SHOW_PAYWALL)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!user) return <></>

  const displayBundling = !!localStorage.getItem(
    localStorageItems.wasRoutedFromExternalCoachMarketing
  )

  return (
    <>
      {displayBundling ? <PaywallBundling /> : <PaywallNoBundling />}
      <PaywallReferralModal />
    </>
  )
}

const PaywallWithAuth = requireAuth(Paywall)
export default PaywallWithAuth
